import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Checkbox from '@material-ui/core/Checkbox';
import blueGrey from '@material-ui/core/colors/blueGrey';
import grey from '@material-ui/core/colors/grey';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import * as React from 'react';
import * as Stickyfill from 'stickyfilljs';

import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ImstatOnGoing from '../containers/ImstatOnGoing';
import ImstatResult from '../containers/ImstatResult';
import i18n from '../resources/i18n';
import { isValid, MasterItemCode } from '../utils/MasterData';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IUserAttr } from '../actions/session';
import { IRootState } from '../reducers';
import ScenariFactory from '../scenario/ImstatScenarioFactory';

const styles = (theme: Theme) =>
	createStyles({
		accessBar: {
			marginTop: theme.spacing(1),
			position: 'sticky',
			top: theme.spacing(1),
			zIndex: 10,
		},
		accessButton: {
			textTransform: 'none',
			[theme.breakpoints.down('sm')]: {
				fontSize: '0.625rem',
			},
		},
		accessButtonCurrim: {
			borderTopRightRadius: 0,
			textTransform: 'none',
			[theme.breakpoints.down('sm')]: {
				fontSize: '0.625rem',
			},
		},
		accessButtonElearn: {
			borderBottomLeftRadius: 0,
			borderTopLeftRadius: 0,
			textTransform: 'none',
			[theme.breakpoints.down('sm')]: {
				fontSize: '0.625rem',
			},
		},
		accessButtonTop: {
			borderBottomRightRadius: 0,
			borderRight: '1px solid rgba(48,63,159,1.000)',
			borderTopRightRadius: 0,
			display: 'flex',
			textTransform: 'none',
			[theme.breakpoints.down('sm')]: {
				fontSize: '0.625rem',
			},
		},
		accessor: {
			backgroundColor: 'rgba(55,71,79,0.5)',
			borderBottomLeftRadius: '1em',
			borderTopLeftRadius: '1em',
			color: grey[50],
			display: 'flex',
			float: 'left',
			paddingBottom: theme.spacing(1),
			paddingLeft: theme.spacing(2),
			paddingRight: theme.spacing(1),
			paddingTop: theme.spacing(1),
		},
		accessorLeft: {
			display: 'flex',
			float: 'left',
		},
		accessorRight: {
			float: 'right',
		},
		accessordiv: {
			backgroundColor: 'rgba(63,81,181,1.000)',
			borderBottomRightRadius: '4px',
			borderTopRightRadius: '4px',
			paddingRight: theme.spacing(1),
			textTransform: 'none',
			[theme.breakpoints.down('sm')]: {
				fontSize: '0.625rem',
			},
		},
		accessordivtrue: {
			backgroundColor: 'rgba(63,81,181,1.000)',
			borderBottom: '1px solid rgba(48,63,159,1.000)',
			borderBottomRightRadius: 0,
			borderTopRightRadius: '4px',
			paddingRight: theme.spacing(1),
			textTransform: 'none',
			[theme.breakpoints.down('sm')]: {
				fontSize: '0.625rem',
			},
		},
		bottomNavigation: {
			backgroundColor: blueGrey[50],
			bottom: 0,
			position: 'fixed',
			width: '100%',
		},
		checkbox: {
			color: 'rgba(255, 255, 255, 1.000)',
			height: 34,
			width: 34,
		},
		hidden: {
			visibility: 'hidden',
		},
		root: {
			padding: theme.spacing(1),
		},
	});

interface IMyProps {
	tableNumber: number;
	navigate?: string;
}

interface IState {
	careerTypeON: boolean;
	onlyQualificationDispalyFlg: string;
	tabNumber: number;
}

/**
 * 実施状況メインコンポーネント
 */
class StatusMain extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			careerTypeON: true,
			onlyQualificationDispalyFlg: '0',
			tabNumber: 0,
		};
	}
	public render() {
		const { classes } = this.props;

		return (
			<div className={classes.root}>
				<Tabs
					value={this.state.tabNumber}
					onChange={this.handleChange}
					indicatorColor="primary"
					textColor="primary"
					centered={true}
				>
					<Tab label={i18n.t('StatusMain_0001')} />
					<Tab label={i18n.t('StatusMain_0002')} />
				</Tabs>

				{isValid(MasterItemCode.CAREER_TYPE_CONTROL) && (
					<Grid
						container={true}
						justify="flex-end"
						className={classes.accessBar}
						ref={(el: HTMLDivElement) => el && Stickyfill.add(el)}
					>
						<Grid item={true}>
							<div className={classes.accessor}>
								<div className={classes.accessorLeft}>
									<Button
										variant="contained"
										color="primary"
										className={classes.accessButtonTop}
										onClick={this.handlNavigate()}
									>
										<ArrowUpwardIcon />
									</Button>
								</div>
								<div className={classes.accessorRight}>
									<div className={classes.accessordivtrue}>
										<Checkbox
											className={classes.checkbox}
											id="cancel"
											color="default"
											checked={
												this.state
													.onlyQualificationDispalyFlg ===
												'1'
													? true
													: false
											}
											onChange={
												this
													.changeQualificationDispalyFlg
											}
										/>
										{i18n.t('StatusMain_0007')}
									</div>
									<div>
										<ButtonGroup
											variant="contained"
											color="primary"
											size="small"
										>
											<Button
												className={
													classes.accessButtonElearn
												}
												onClick={this.handlNavigate(
													'e-learning'
												)}
											>
												{i18n.t('StatusMain_0003')}
											</Button>
											<Button
												className={classes.accessButton}
												onClick={this.handlNavigate(
													'group-training'
												)}
											>
												{i18n.t('StatusMain_0004')}
											</Button>
											<Button
												className={classes.accessButton}
												onClick={this.handlNavigate(
													'distance-learning'
												)}
											>
												{i18n.t('StatusMain_0005')}
											</Button>
											<Button
												className={
													classes.accessButtonCurrim
												}
												onClick={this.handlNavigate(
													'curriculum'
												)}
											>
												{i18n.t('StatusMain_0006')}
											</Button>
										</ButtonGroup>
									</div>
								</div>
							</div>
						</Grid>
					</Grid>
				)}
				{!isValid(MasterItemCode.CAREER_TYPE_CONTROL) && (
					<Grid
						container={true}
						justify="flex-end"
						className={classes.accessBar}
						ref={(el: HTMLDivElement) => el && Stickyfill.add(el)}
					>
						<Grid item={true}>
							<div className={classes.accessor}>
								<ButtonGroup
									variant="contained"
									color="primary"
									size="small"
								>
									<Button
										className={classes.accessButton}
										onClick={this.handlNavigate()}
									>
										<ArrowUpwardIcon />
									</Button>
									<div className={classes.accessordiv}>
										<Checkbox
											className={classes.checkbox}
											id="cancel"
											color="default"
											checked={
												this.state
													.onlyQualificationDispalyFlg ===
												'1'
													? true
													: false
											}
											onChange={
												this
													.changeQualificationDispalyFlg
											}
										/>
										{i18n.t('StatusMain_0007')}
									</div>
								</ButtonGroup>
							</div>
						</Grid>
					</Grid>
				)}

				{this.state.tabNumber === 0 && (
					<ImstatOnGoing
						onlyQualificationDispalyFlg={
							this.state.onlyQualificationDispalyFlg
						}
					/>
				)}
				{this.state.tabNumber === 1 && (
					<ImstatResult
						onlyQualificationDispalyFlg={
							this.state.onlyQualificationDispalyFlg
						}
					/>
				)}
			</div>
		);
	}

	protected changeQualificationDispalyFlg = (
		event: React.ChangeEvent<HTMLInputElement>,
		value?: any
	) => {
		let QualificationDispalyFlg = '0';
		if (value === false) {
			QualificationDispalyFlg = '0';
			this.setState({ onlyQualificationDispalyFlg: '0' });
		} else {
			QualificationDispalyFlg = '1';
			this.setState({ onlyQualificationDispalyFlg: '1' });
		}
		if (this.state.tabNumber === 0) {
			this.props.fetchOnGoingCurriculum(
				this.props.token,
				this.props.userAttr,
				QualificationDispalyFlg
			);
			this.props.fetchOnGoingELearning(
				this.props.token,
				this.props.userAttr,
				QualificationDispalyFlg
			);
			if (isValid(MasterItemCode.CAREER_TYPE_CONTROL)) {
				this.props.fetchOnGoingDistanceLearning(
					this.props.token,
					this.props.userAttr,
					QualificationDispalyFlg
				);
				this.props.fetchOnGoingGroupTraining(
					this.props.token,
					this.props.userAttr,
					QualificationDispalyFlg
				);
			}
		}
		if (this.state.tabNumber === 1) {
			this.props.fetchResultELearning(
				this.props.token,
				this.props.userAttr,
				QualificationDispalyFlg
			);
		}
	};

	/**
	 * タブ変更ハンドラ
	 */
	protected handleChange = (event: React.ChangeEvent<{}>, value: any) => {
		this.setState({ tabNumber: value });
	};

	/**
	 * ナビゲーションハンドラ
	 */
	protected handlNavigate = (targetId?: string) => (
		event: React.MouseEvent
	) => {
		if (!targetId) {
			window.scrollTo({
				behavior: 'smooth',
				top: 0,
			});
			return;
		}

		const target = document.querySelector('div#' + targetId);
		if (!target) {
			return;
		}
		target.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
			inline: 'nearest',
		});
	};
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchOnGoingCurriculum: (
		token: string,
		arg: IUserAttr,
		onlyQualificationDispalyFlg: string
	) => {
		const s = ScenariFactory.createFetchOnGoingCurriculum(
			dispatch,
			token,
			onlyQualificationDispalyFlg
		);
		s.run(arg);
	},
	fetchOnGoingDistanceLearning: (
		token: string,
		arg: IUserAttr,
		onlyQualificationDispalyFlg: string
	) => {
		const s = ScenariFactory.createFetchOnGoingDistanceLearning(
			dispatch,
			token,
			onlyQualificationDispalyFlg
		);
		s.run(arg);
	},
	fetchOnGoingELearning: (
		token: string,
		arg: IUserAttr,
		onlyQualificationDispalyFlg: string
	) => {
		const s = ScenariFactory.createFetchOnGoingELearning(
			dispatch,
			token,
			onlyQualificationDispalyFlg
		);
		s.run(arg);
	},
	fetchOnGoingGroupTraining: (
		token: string,
		arg: IUserAttr,
		onlyQualificationDispalyFlg: string
	) => {
		const s = ScenariFactory.createFetchOnGoingGroupTraining(
			dispatch,
			token,
			onlyQualificationDispalyFlg
		);
		s.run(arg);
	},
	fetchResultELearning: (
		token: string,
		arg: IUserAttr,
		onlyQualificationDispalyFlg: string
	) => {
		const s = ScenariFactory.createFetchResultELearning(
			dispatch,
			token,
			onlyQualificationDispalyFlg
		);
		s.run(arg);
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IMyProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(StatusMain);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/StatusMain.tsx